if($('.eshopCategories').length){
    $(function () {
        const STORAGE_KEY = 'shoptet_categories__' + window.location.hostname;
        const cached = sessionStorage.getItem(STORAGE_KEY);
        if (cached) {
            const categories = JSON.parse(cached);
           // console.log('Načteno ze sessionStorage', categories);
            useCategories(categories);
            categoriesSlider();
            return;
        }
        $.ajax({
            url: produktyURL,
            method: 'GET',
            dataType: 'html',
            success: function (html) {
                const $html = $('<div>').html(html);
                const categories = [];
                $html.find('ul.subcategories.with-image > li').each(function () {
                    const $a = $(this).find('a').first();
                    const url = $a.attr('href') || '';
                    const name = $.trim($a.find('.text').text());
                    const $img = $a.find('img').first();
                    let image = $img.data('src') || $img.attr('src') || '';
                    image = image.replace('/thumb/', '/orig/');
                    if (name && url) {
                        categories.push({
                            name,
                            url,
                            image
                        });
                    }
                });
                sessionStorage.setItem(STORAGE_KEY, JSON.stringify(categories));
               // console.log('Staženo a uloženo', categories);
                useCategories(categories);
                categoriesSlider();
            },
            error: function () {
                console.error('Nepodařilo se načíst '+produktyURL);
            }
        });
        function useCategories(categories) {
            const $wrap = $('.eshopCategories .categoriesInner').empty();
            categories.forEach(cat => {
                $wrap.append(`
                    <div class="categoriesItem">
                        <div class="innerWrap">
                            <a href="${cat.url}" class="category-item">
                                <div class="inner">
                                    <img src="${cat.image}" alt="${cat.name}">
                                    <span>${cat.name}</span>
                                </div>
                            </a>
                        </div>
                    </div>
                `);
            });
        }
        function categoriesSlider(){
            $('.categoriesInner').slick({
                slidesToShow: 6,
                slidesToScroll: 1,
                centerMode: false,
                autoplay: false,
                autoplaySpeed: 5000,
                dots: true,
                arrows: true,
                infinite: false,
                adaptiveHeight: false,
                appendArrows: $('.eshopCategories .brandArrows'),
                responsive: [
                    { breakpoint: 1199, settings: { slidesToShow: 5, slidesToScroll: 1 } },
                    { breakpoint: 1000, settings: { slidesToShow: 4, slidesToScroll: 1, arrows: false } },
                    { breakpoint: 767, settings: { slidesToShow: 3, slidesToScroll: 1, arrows: false } },
                    { breakpoint: 550, settings: { slidesToShow: 2, slidesToScroll: 1,dots: false, } },
                    { breakpoint: 330, settings: { slidesToShow: 1, slidesToScroll: 1,dots: false, } }
                ]
                });
        }
    });

}